<template>
    <div v-text='info'></div>
</template>
<script>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { useStore } from 'vuex'
export default {
    setup () {
        // const info = ref("")
        const router = useRouter()
        const store = useStore()
        const $loading = useLoading()
        onMounted(()=>{        
            // window.setValue = (r) => {
            //     info.value = r
            // }
            window.helloInfo = function (resp) {
                // info.value = resp
                let jj = JSON.parse(JSON.stringify(resp))
                // alert(resp)
                // const $loader = $loading.show({
                //     "container":null
                // })
                let sign = jj['sign']
                if(!sign) {
                    const $loader = $loading.show({
                        "container":null
                    })  
                    store.dispatch("customLogin", {
                            params:jj,
                            customHeader:{
                                deviceId:jj.deviceId,
                                version:jj.version,
                                idfv:jj.idfv,
                                idfa:jj.idfa,
                                sdkVersion:jj.systemVersion,
                                brand:jj.model,
                            }
                    }).then(()=>{
                        $loader.hide()
                        router.replace({
                            "path":"/"
                        })
                    })                
                } else {
                    store.dispatch("customLogin2", {
                            params:jj,
                            customHeader:{
                                deviceId:jj.deviceId,
                                version:jj.version,
                                idfv:jj.idfv,
                                idfa:jj.idfa,
                                sdkVersion:jj.systemVersion,
                                brand:jj.model,
                            }
                    }).then(()=>{
                        // $loader.hide()
                        router.replace({
                            "path":"/"
                        })
                    }) 
                }
                
            }            
            window.GetInfo.postMessage('helloInfo');            
        })   
        // return {
        //     info
        // }     
    }
}
</script>